<template>
  <div v-loading.body="loading">
    <div class="c_page-title">
      <div>上架单详情</div>
    </div>
    <el-row class="filter">
      <el-col>
        <div
          style="
            background: #f3f3f3;
            height: 30px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>筛选查询</div>
          <el-button
            type="text"
            style="margin-left: auto"
            :icon="filterFold ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"
            @click="toggleFilter"
            >{{ filterFold ? "展开筛选" : "收起筛选" }}</el-button
          >
        </div>
        <el-collapse-transition>
          <div v-show="!filterFold">
            <div style="padding: 10px 25px">
              <el-form :inline="true" :model="form" class="demo-form-inline">
                <el-form-item label="输入搜索：">
                  <el-input
                    v-model="form.sku"
                    placeholder="商品sku"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
                <el-form-item>
                  <el-input
                    v-model="form.dbid"
                    placeholder="打标id"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>

                <el-form-item>
                  <el-button type="primary" @click="search">查询</el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </el-collapse-transition>
      </el-col>
    </el-row>

    <!-- 表格 -->
    <el-row>
      <el-col style="border: 1px solid #ddd">
        <div
          style="
            background: #f3f3f3;
            height: 50px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>数据列表：</div>
        </div>
        <div v-if="resData" style="margin-bottom: 0">
          <el-table
            ref="multipleTable"
            v-loading="tableLoading"
            height="600"
            :data="resData"
            tooltip-effect="dark"
          >
            <el-table-column prop="goods_img" label="商品图片" align="center">
              <template slot-scope="scope">
                <div
                  v-viewer
                  style="
                    width: 40px;
                    height: 40px;
                    overflow: hidden;
                    cursor: pointer;
                    display: inline-block;
                  "
                >
                  <img
                    v-for="(item, index) in scope.row.middle_img"
                    :key="index"
                    :src="item"
                    style="width: 100%; height: 100%"
                  />
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="goods_name"
              label="商品名称"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="sku"
              label="商品sku"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="co_val"
              label="颜色"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="si_val"
              label="尺码"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="supply_name"
              label="商家"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="pgname"
              label="代采组"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="wx_nick_name"
              label="代采员"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="dbid"
              label="打标id"
              show-overflow-tooltip
              align="center"
            >
              <template slot-scope="scope">
                <!-- <div @click="openQrCode('dbid=' + scope.row.dbid)">
                  {{ scope.row.dbid }}
                </div> -->
                <el-button
                  type="text"
                  @click="openQrCode('dbid=' + scope.row.dbid)"
                  >{{ scope.row.dbid }}</el-button
                >
              </template>
            </el-table-column>
            <el-table-column
              prop="upshelf_detail_status"
              label="状态"
              width="100"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
          </el-table>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import QrcodeVue from "qrcode.vue";
import apiBaseURL from "@/utils/baseUrl.js";

import Global_ from "../components/Global";

export default {
  name: "UpShelfDetail",
  components: {
    QrcodeVue,
  },
  data() {
    return {
      resData: null,
      form: {
        us_id: this.$route.params.id,
      },
      loading: false,
      url: "/erp/Upshelf/detail",
      currentPage: 1,
      tableLoading: false,
      filterFold: false,
      statusOption: [],
    };
  },
  computed: {
    filteredForm() {
      for (const key in this.form) {
        if (
          this.form[key] === undefined ||
          this.form[key] === "" ||
          this.form[key] === null
        ) {
          delete this.form[key];
        }
      }
      return this.form;
    },
  },

  created() {
    this.fetchData();
  },
  methods: {
    openQrCode(text) {
      if (Global_.environment === 0) {
        const h = this.$createElement;
        this.$msgbox({
          title: text,
          center: true,
          showConfirmButton: false,
          message: h(
            "QrcodeVue",
            {
              props: {
                value: text,
                size: 152,
                level: "H",
              },
            },
            null
          ),
        });

        // this.$alert(
        //   // `<img src="https://tool.oschina.net/action/qrcode/generate?data=${text}" style='width: 152px; height:152px'/>`,
        //   `<qrcode-vue :value="https://tool.oschina.net/action/qrcode/generate?data=${text}" :size="152" level="H" />`,
        //   text,
        //   {
        //     dangerouslyUseHTMLString: true,
        //     showConfirmButton: false,
        //     closeOnClickModal: true,
        //     center: true,
        //   }
        // );
      }
    },
    handleSizeChange(e) {
      this.form.page_size = e;
      this.fetchData();
    },
    output() {
      this.form.is_excel = 1;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.form.is_excel = 0;
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            window.open(apiBaseURL + res.data.data.file);
          }
        }
      });
    },
    toggleFilter() {
      this.filterFold = !this.filterFold;
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleCurrentChange(val) {
      this.form.page = val;
      this.tableLoading = true;
      this.$http.post(this.url, this.form).then((res) => {
        setTimeout(() => {
          this.tableLoading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
    search() {
      this.form.page = 1;
      this.loading = true;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        setTimeout(() => {
          this.loading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
          this.currentPage = 1;
        }
      });
    },
    fetchData(showLoading) {
      if (showLoading) {
        this.loading = true;
      }
      this.$http.post(this.url, this.filteredForm).then((res) => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
          this.statusOption = res.data.data.statusOption;
        }
      });
    },
  },
};
</script>

<style scoped>
.filter {
  border: 1px solid #ddd;
}
</style>



// WEBPACK FOOTER //
// src/pages/UpshelfDetail.vue